export const addDataLayerEvent = () => {

    /**
     * Apply now
     * @type {HTMLAnchorElement}
     */
    const applyNowBtn = document.querySelector('.subnav-button a');
    if(applyNowBtn){
        applyNowBtn.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                "event": "click.action",
                "click": applyNowBtn.text,
                "click_link": applyNowBtn.href,
            });
        })
    }

    /**
     * Read more with class .more2
     * @type {HTMLCollection}
     */
    const more2Btns = document.querySelectorAll('.more2');
    let more2btnsArray = more2Btns?.length > 0 ? Array.from(more2Btns) : [];

    const ctaBtns = document.querySelectorAll('.cta-button');
    let ctaBtnsArray = ctaBtns?.length > 0 ? Array.from(ctaBtns) : [];

    const ctaLinks = document.querySelectorAll('.cta-link');
    let ctaLinksArray = ctaLinks?.length > 0 ? Array.from(ctaLinks) : [];

    const ctaBtns2 = document.querySelectorAll('.cta-btn');
    let ctaBtns2Array = ctaBtns2?.length > 0 ? Array.from(ctaBtns2) : [];

    // const footerSocials = document.querySelectorAll('.footer-class');
    // let footerSocialsArray = footerSocials?.length > 0 ? Array.from(footerSocials) : [];

    const downloadAnchors = document.querySelectorAll("a[type=download]");
    let downloadAnchorsArray = downloadAnchors?.length > 0 ? Array.from(downloadAnchors): [];

    const defaultDownloadButtons = document.querySelectorAll('.wp-block-button__link');
    let defaultDownloadButtonsArray = defaultDownloadButtons?.length > 0 ? Array.from(defaultDownloadButtons): [];


    const readMoreBtns = [
        ...more2btnsArray,
        ...ctaBtnsArray,
        ...ctaLinksArray,
        ...ctaBtns2Array,
    ]

    if(readMoreBtns && readMoreBtns.length > 0){
        readMoreBtns.forEach(readMoreBtn => {
            if(readMoreBtn){
                readMoreBtn.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                        "event": "click.action",
                        "click": readMoreBtn.text.trim(),
                        "click_link": readMoreBtn.href,
                    });
                })
            }
        })
    }


    if(downloadAnchorsArray && downloadAnchorsArray.length > 0){
        downloadAnchorsArray.forEach(readMoreBtn => {
            if(readMoreBtn){
                readMoreBtn.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                        "event": "click.download",
                        "click": readMoreBtn.text.trim(),
                        "click_link": readMoreBtn.href,
                    });
                })
            }
        })
    }

    if(defaultDownloadButtonsArray && defaultDownloadButtonsArray.length > 0){
        defaultDownloadButtonsArray.forEach(readMoreBtn => {
            if(readMoreBtn){
                readMoreBtn.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                        "event": "click.download",
                        "click": readMoreBtn.text.trim(),
                        "click_link": readMoreBtn.href,
                    });
                })
            }
        })
    }

    //Article socials

    /**
     * @type {HTMLLIElement[]}
     */
    const socialNavs = document.querySelectorAll('.article-social .social-nav li');

    for(let socialNav of socialNavs){
        if(socialNav){
            socialNav.addEventListener('click', (event) => {
                //look for a element
               if(event?.currentTarget){
                   const anchor = event.currentTarget.querySelector('a');
                   if(anchor){
                       window.dataLayer = window.dataLayer || []
                       window.dataLayer.push({
                           "event": "click.action",
                           "click": anchor.text.trim(),
                           "click_link": anchor.href,
                       });
                   }
               }

            })
        }
    }


    // //Forms
    // /**
    //  * @type {HTMLFormElement[]}
    //  */
    // const forms = document.querySelectorAll('form');
    // for(let form of forms){
    //     console.log(form,'inside custom datalayer form');
    //     form.addEventListener('submit', (e) => {
    //         console.log('form submitted inside custom datalayer form')
    //         // const submitter = form.querySelector("button[value=Save]");
    //         const formData = new FormData(e.target);
    //         console.log(formData,'formdata');
    //         window.dataLayer = window.dataLayer || []
    //         if(formData){
    //             window.dataLayer.push({
    //                 "event": "form.submit",
    //                 "form_name": formData.get('form_title'),
    //                 "form_id": formData.get('form_id'),
    //             });
    //         }
    //     })
    // }

    //Search

    /**
     * @type {HTMLInputElement}
     */
    const commonTopSearchInput = document.querySelector('.common-top-search-input');

    /**
     * @type {HTMLButtonElement}
     */
    const commonTopSearchBtn = document.querySelector('.common-top-search-button');

    if(commonTopSearchInput && commonTopSearchBtn){
        commonTopSearchBtn.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            try {
                window.dataLayer.push({
                    "event": "internal_search_result.display",
                    "ise_keyword": commonTopSearchInput.value,
                    "ise_page": 1,
                    "ise_engine": "site_search"
                })
            } catch (e) {

            }
        })
    }
}